import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Skeleton from "@material-ui/lab/Skeleton";
import DividerVertical from "../Misc/DividerVertical";

const useStyles = makeStyles((theme) => ({
  name: { marginBottom: theme.spacing(1.5) },
  lineDetails: { display: "flex" },
  lineDetailsLeftSide: {
    width: `calc(50% - ${theme.spacing(1.5)}px)`,
  },
  lineDetailsRighSide: { width: `calc(50% - ${theme.spacing(1.5)}px)` },
  lineDetailsDivider: {
    marginRight: theme.spacing(1.5),
    marginLeft: theme.spacing(1.5),
  },
  item: { marginBottom: theme.spacing(1) },
}));

export default function LineSummaryPlaceholder() {
  const classes = useStyles();
  return (
    <div>
      <Skeleton className={classes.name} />
      <div className={classes.lineDetails}>
        <div className={classes.lineDetailsLeftSide}>
          <Skeleton className={classes.item} />
          <Skeleton className={classes.item} />
        </div>
        <div className={classes.lineDetailsDivider}>
          <DividerVertical />
        </div>
        <div className={classes.lineDetailsRighSide}>
          <Skeleton className={classes.item} />
          <Skeleton className={classes.item} />
        </div>
      </div>
    </div>
  );
}
